import { FormQuestion, FormSection, UploadFile } from "generated/openApi";

export type TransientQuestionResponse = {
  questionId: number;
  writeIn: string | null;
  writeInDate: string | null;
  writeInDecimal: number | null;
  formAnswers: TransientFormAnswer[];
  signatureFile: any | null;
  fileUpload: UploadFile | null;
};

export type TransientFormAnswer = {
  formAnswerId?: number | null;
  formEntityId?: number;
  subQuestionId?: number;
  writeIn?: string;
};

export type ActiveQuestionPage = {
  questionIds: number[];
  pageIndex: number;
};

export type SurveyPage = {
  pageIndex: number;
  questions: FormQuestion[];
  sections: FormSection[];
};

export const responseHasAnswer = (response: TransientQuestionResponse) : boolean => {
  if (response.writeIn != null || response.writeInDate != null || response.signatureFile != null || response.fileUpload != null || (response.formAnswers != null && response.formAnswers.length > 0)) {
    return true;
  }
  return false;
}